import axios from "axios";
import router from "@/router";
import { throwErr } from "@/api/throw_err";
// import { message } from "ant-design-vue";
import Config from "@/config";
const authList = ["auth", "oauth", "anonymous"];

const req = axios.create({
  baseURL: "http://uuc.it.czczh.cn/gw/novauc/",
  timeout: Config.API_TIMEOUT // 请求超时时间
});

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url.split("?")[0]) {
      //当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
};

//请求拦截器
req.interceptors.request.use(
  config => {
    // config.timeout = defaultSettings.axiosTimeOut //请求响应时间

    removePending(config); //在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken(c => {
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      let m = { u: config.url.split("?")[0], f: c };
      pending.push(m);
    });

    // !authList.some(item => config.url.split('/')[0] == item)
    if (!authList.includes(config.url.split("/")[0])) {
      config.baseURL = Config.API_URL; // 后台 api 的 url
    }

    let token =
      sessionStorage.getItem(Config.TOKEN_KEY) ||
      sessionStorage.getItem("10015_yc_token");
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      if (
        authList.includes(config.url.split("/")[0]) &&
        config.auth !== false
      ) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        config.headers.token = token;
      }
    } else {
      router.replace({ name: "login" });
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
req.interceptors.response.use(
  response => {
    removePending(response.config);
    return response;
  },
  error => {
    if (error && error.response) {
      error.message = throwErr(error.response.status); //throwErr 捕捉服务端的http状态码 定义在utils工具类的方法
      switch (error.response.status) {
        case 401:
          router.replace({ name: "login" }).catch(err => {
            console.log("err:");
            console.log(err);
          });
          break;
      }
    }
    return Promise.reject(error);
  }
);

export { req };
